export enum PreventionType {
    None = 0,
    Notification = 1,
    Prevent = 2,
}